/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, Dispatch, SetStateAction, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { TrailersFilters } from '../types'

type ContextState = {
  filters: TrailersFilters
  setFilters: Dispatch<SetStateAction<TrailersFilters>>
  isTrailersSync: boolean
  setIsTrailersSync: Dispatch<SetStateAction<boolean>>
  resetFilters: () => void
  resetTriggered: number
}

export const initialTrailersFiltersState: ContextState = {
  filters: { page: 1, limit: 10, orderBy: 'ASC' },
  setFilters: () => {},
  isTrailersSync: false,
  setIsTrailersSync: () => {},
  resetFilters: () => {},
  resetTriggered: 0,
}

const TrailersContext = React.createContext<ContextState>(initialTrailersFiltersState)

type TrailersFiltersProviderProps = {
  children: React.ReactNode
}

export function TrailersFiltersProvider({ children }: TrailersFiltersProviderProps) {
  const [isTrailersSync, setIsTrailersSync] = useState<boolean>(false)
  const [filters, setFilters] = useState<TrailersFilters>(initialTrailersFiltersState.filters)
  const [resetTriggered, setResetTriggered] = useState<number>(0)
  const [search] = useSearchParams()
  const resetFilters = () => {
    setResetTriggered(state => state + 1)
  }

  useEffect(() => {
    if (resetTriggered) {
      setFilters(initialTrailersFiltersState.filters)
    }
  }, [resetTriggered])

  useEffect(() => {
    if (filters && search.get('service') && !filters.asnum) {
      const timeout = setTimeout(
        () =>
          setFilters(state => ({
            ...state,
            asnum: Number(search.get('service')) ?? undefined,
            page: initialTrailersFiltersState.filters.page,
          })),
        0,
      )

      return () => clearTimeout(timeout)
    } else {
      setFilters(initialTrailersFiltersState.filters)
    }
  }, [search])

  return (
    <TrailersContext.Provider
      value={{
        filters,
        setFilters,
        isTrailersSync,
        setIsTrailersSync,
        resetFilters,
        resetTriggered,
      }}
    >
      {children}
    </TrailersContext.Provider>
  )
}

export function useTrailersContext(): ContextState {
  const context = useContext(TrailersContext)
  if (!context)
    throw Error('This hook can only be used under the TrailersFiltersProvider component')
  return context
}
